import gql from 'graphql-tag';

export const GET_VALUATION_BRANCH = gql`
    query ValuationBranch($branchId: Int!) {
        valuationBranch(branchId: $branchId) {
            address
            averageRentPrice
            averageSalePrice
            branchDisplayName
            branchId
            logo
            numberOfSaleListings
            numberOfRentListings
            outcode
            postcode
        }
    }
`;
